/* src/app/shared/components/preference/preference.component.scss */
.ahe-ui-radio-list .ahe-ui-radio:not(:last-child) {
  box-shadow: none;
}
.ahe-ui-radio > input[type=radio] + span::before {
  margin-top: 1px;
}
.line-divider {
  border-top: 1px solid #bdbdbd;
}
.relative-top {
  position: relative;
  top: 16px;
}
.page-title {
  font-size: 20px;
}
.instructions-textarea {
  font-family: Times New Roman;
  font-size: 14pt;
  width: 30% !important;
  line-height: 26px;
  min-height: 38px;
}
@media (max-width: 768px) {
  .instructions-textarea {
    width: 100% !important;
  }
}
.smokeBgColor {
  background-color: #f5f5f5 !important;
}
.fontSize18 {
  font-size: 18px;
}
.textWidth {
  max-width: 100px;
  display: inline;
}
.verticalDot {
  background-color: #e8e8e8;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  float: left;
  margin-top: 0px;
}
.verticalBar {
  background-color: #e8e8e8;
  height: 10px;
  width: 90px;
  margin-left: 15px;
  margin-top: 10px;
}
.questionBar {
  background-color: #b0b0b0;
  height: 30px;
  width: 180px;
}
.horizontalDot1 {
  background-color: #e8e8e8;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  float: left;
  margin-top: 0px;
}
.horizontalDot2 {
  background-color: #e8e8e8;
  height: 10px;
  width: 10px;
  margin-left: 70px;
  border-radius: 5px;
  margin-top: -10px;
}
.horizontalDot3 {
  background-color: #e8e8e8;
  height: 10px;
  width: 10px;
  margin-left: 140px;
  border-radius: 5px;
  margin-top: -10px;
}
.horizontalBar1 {
  background-color: #e8e8e8;
  height: 10px;
  width: 40px;
  margin-left: 15px;
  margin-top: 10px;
}
.horizontalBar2 {
  background-color: #e8e8e8;
  height: 10px;
  width: 40px;
  margin-left: 85px;
  margin-top: -10px;
}
.horizontalBar3 {
  background-color: #e8e8e8;
  height: 10px;
  width: 40px;
  margin-left: 155px;
  margin-top: -10px;
}
.saLines {
  background-color: #e8e8e8;
  height: 3px;
  width: 150px;
  margin-top: 10px;
}
.saBlanks {
  height: 40px;
  width: 150px;
  margin-top: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: #e8e8e8;
}
hr {
  width: 3px;
  background-color: #e8e8e8;
  opacity: 0.5;
  margin-right: 50px;
  margin-top: 15px;
  margin-bottom: 0px;
  height: 320px;
  float: left;
}
@media (max-width: 768px) {
  hr {
    width: 100%;
    height: 3px;
    margin: 20px 0;
  }
}
.handles {
  cursor: move;
}
#header-order #header-container {
  width: 100%;
}
#header-order #header-container .header-types {
  padding-top: 10px;
}
#header-order #header-container #header-rename-text {
  text-align: right;
}
#header-order #header-container .rename-edit-icon {
  padding-top: 8px;
}
#header-order #header-container .rename-edit {
  padding-top: 4px;
}
.answerBlanksBar {
  height: 15px;
  width: 25%;
  border-style: solid;
  border-width: 1px;
  border-color: #e8e8e8;
}
.modal-dialog-settings-changed {
  position: relative;
  top: 50%;
  width: 95dvw;
  max-width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-settings-changed .modal-content {
  height: 200px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #174d5c;
  color: #fff;
  height: 44px;
  padding: 12px 18px 12px 18px;
}
.modal-header-new #modalHeader {
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.modal-body-settings-changed {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 30px 0 30px;
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background-color: #f0f3f4;
}
.modal-footer-new button {
  width: 130px;
}
.qtiTypes {
  margin-left: 10px;
  display: grid;
}
.padding-top-bottom {
  padding-top: 15px;
  padding-bottom: 15px;
}
.kebab-preference-align {
  margin-left: -7px;
  bottom: 27px;
  position: relative;
}
.padding-top {
  padding-top: 15px;
}
.btn-primary {
  background-color: #007c91;
  border-color: #2e6da4;
}
.btn {
  line-height: 0;
}
.preferncesMinHeight {
  min-height: 250px;
}
.increaseHeightDocxCont {
  height: 2750px;
}
.source-container {
  padding-bottom: 50px;
}
.decreaseHeightDocxCont {
  height: auto;
}
.subtitle {
  font-size: 16px;
  font-weight: normal;
  margin-left: 20px;
}
.ahe-ui-radio > input[type=radio] {
  transform: translateY(0em) !important;
  margin: 4px !important;
}
.align-vertical {
  display: grid;
}
.ahe-ui-checkbox > input[type=checkbox] {
  transform: translateY(0em) !important;
  margin: 5px !important;
}
.alignment {
  flex-wrap: nowrap !important;
}
.preferences h1,
.preferences h2,
.preferences h3 {
  font-weight: bold;
  margin: 0;
  color: inherit;
  font-size: 18px;
}
.preferences #exportAsSectionHeading,
.preferences #answerKeySectionHeading,
.preferences #questionNumberHeading,
.preferences #displayQuestionTypeHeading,
.preferences #layoutSectionHeading,
.preferences #spacingSectionHeading {
  font-size: 16px;
}
.custom-underline-button {
  background: none;
  border: none;
  font-weight: bold;
}
.ahe-ui-radio > input[type=radio]:focus + span::before {
  outline: 2px solid #265867;
}
.ahe-ui-checkbox > input[type=checkbox]:focus + span::before {
  outline: 2px solid #265867;
}
.radio-label-margin {
  margin-right: -36px;
}
.restart-page-number {
  margin-left: 36px;
}
.character-count {
  font-size: 16px;
}
.form-control.input-error,
.form-control:focus.input-error {
  border: 1px solid #b0181e !important;
  box-shadow: 0 2px 0 0 red;
}
.rename-button {
  text-decoration: underline;
  box-sizing: border-box;
  color: #017890;
  height: auto;
  line-height: normal;
  border: 0;
  background: transparent;
}
.rename-button:focus {
  outline: 2px solid black;
}
.custom-icon-btn {
  background: inherit;
  border: none;
  height: 24px;
  padding-left: 4px;
  padding-right: 4px;
}
.custom-icon-btn:disabled {
  opacity: 0.4;
}
.custom-icon-btn:focus {
  outline: 2px solid black;
}
.header-desc {
  max-width: 224px;
}
.close {
  height: 20px;
  width: 20px;
  opacity: 1;
}
button.close:focus,
button.close:focus-visible,
button.close:focus:not(:focus-visible) {
  outline: auto;
  outline-offset: 0;
  background-color: transparent;
}
button.close:not([disabled]):hover {
  background-color: transparent;
}
@media (max-width: 576px) {
  .header-desc {
    max-width: 263px;
  }
  .modal-dialog-settings-changed .modal-content {
    height: fit-content;
    max-height: 100%;
  }
  .modal-dialog-settings-changed .modal-content .modal-body-settings-changed {
    padding: 16px 12px;
    margin: 0;
  }
  .modal-dialog-settings-changed .modal-content .modal-footer-new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 6px;
  }
}
/*# sourceMappingURL=preference.component.css.map */
